import { Tab, Tabs } from '@mui/material'
import React from 'react'
import { styled as muiStyled } from '@mui/material'

const PURPLE_THEME = {
  primary: '#7450aa',
  light: '#8b6eb8',
  dark: '#47306a',
  lightBg: '#c2b2da',
}

const AntTabs = muiStyled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? 'rgba(194, 178, 218, 0.12)' : 'rgba(116, 80, 170, 0.15)',
  borderRadius: '10px',
  padding: 5,
  minHeight: 44,
  '& .MuiTabs-indicator': {
    backgroundColor: PURPLE_THEME.primary,
    height: 3,
    borderRadius: 3,
  },
  '& .MuiTabs-flexContainer': {
    gap: 4,
  },
}))

const AntTab = muiStyled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  padding: '12px 16px',
  color: 'rgba(116, 80, 170, 0.7)',
  borderRadius: '6px',
  transition: 'all 0.2s ease',
  '&:hover': {
    color: PURPLE_THEME.primary,
    backgroundColor: 'rgba(194, 178, 218, 0.2)',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: PURPLE_THEME.primary,
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: 'white',
  },
  '&.Mui-focusVisible': {
    backgroundColor: PURPLE_THEME.lightBg,
  },
}))

export default function PrescriptionPadPreviewTabs({ previewValue, setPreviewValue }) {
  return (
    <AntTabs centered value={previewValue} onChange={(e, val) => setPreviewValue(val)}>
      <AntTab value="print" label="Paper Rx Template" />
      <AntTab value="pdf" label="Digital Rx Template" />
    </AntTabs>
  )
}
